"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var selectors_1 = require("../inc/selectors");

var default_transitions_1 = require("../inc/default-transitions");

var generateTransition = function generateTransition(pose, key) {
  return __assign({}, pose, {
    transition: default_transitions_1.default.has(key) ? default_transitions_1.default.get(key) : default_transitions_1.default.get('default')
  });
};

var dragPoses = function dragPoses(draggable) {
  var dragging = {};
  var dragEnd = {};
  if (draggable === true || draggable === 'x') dragging.x = dragEnd.x = 0;
  if (draggable === true || draggable === 'y') dragging.y = dragEnd.y = 0;
  return {
    dragging: dragging,
    dragEnd: dragEnd
  };
};

exports.default = function (props) {
  var poses = __assign({
    flip: {}
  }, selectors_1.getPoses(props));

  var draggable = props.draggable;

  if (draggable) {
    var _a = dragPoses(draggable),
        dragging = _a.dragging,
        dragEnd = _a.dragEnd;

    dragging = __assign({}, poses.dragging, dragging);
    dragEnd = __assign({}, poses.dragEnd, dragging);
    poses = __assign({}, poses, {
      dragging: dragging,
      dragEnd: dragEnd
    });
  }

  Object.keys(poses).forEach(function (key) {
    var pose = poses[key];
    poses[key] = pose.transition ? pose : generateTransition(pose, key);
  });
  return poses;
};